module.exports = __webpack_public_path__ + "static/media/pv-logo.8ca3afa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/app/pv-logo.png
// module id = 1736
// module chunks = 0